import React from "react";
import "./Card.css";
import half from "../../../assets/images/star-half-yellow-icon.svg";
const Card = ({
  image = "https://mrwallpaper.com/images/thumbnail/cute-cat-eyes-profile-picture-uq3edzmg1guze2hh.webp",
  name = "Khalid Al-Ghamdi",
  role = "Start up founder",
  rating = 3.5,
  review = "Great value for money. Diamond ballroom in Saudi Arabia offers convenience and prestige. Highly recommended.",
}) => {
  const renderStars = (index, stars) => {
    stars -= 1;
    if (index > stars) {
      if (Math.round(2 * stars) % (2 * (index - 1)) === 1) {
        return (
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="half-star" x1="0" x2="100%" y1="0" y2="0">
                <stop offset="50%" stop-color="#ed5a29" />
                <stop offset="50%" stop-color="#888888" />
              </linearGradient>
            </defs>

            <path
              d="M9.04894 0.927052C9.3483 0.00574112 10.6517 0.00573993 10.9511 0.927051L12.4697 5.60081C12.6035 6.01284 12.9875 6.2918 13.4207 6.2918H18.335C19.3037 6.2918 19.7065 7.53141 18.9228 8.10081L14.947 10.9894C14.5966 11.244 14.4499 11.6954 14.5838 12.1074L16.1024 16.7812C16.4017 17.7025 15.3472 18.4686 14.5635 17.8992L10.5878 15.0106C10.2373 14.756 9.7627 14.756 9.41221 15.0106L5.43648 17.8992C4.65276 18.4686 3.59828 17.7025 3.89763 16.7812L5.41623 12.1074C5.55011 11.6954 5.40345 11.244 5.05296 10.9894L1.07722 8.10081C0.293507 7.53141 0.696283 6.2918 1.66501 6.2918H6.57929C7.01252 6.2918 7.39647 6.01284 7.53035 5.60081L9.04894 0.927052Z"
              fill="url(#half-star)"
            />
          </svg>
        );
      }
    }
    return (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill={index <= stars ? "#FFC107" : "#888888"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.04894 0.927052C9.3483 0.00574112 10.6517 0.00573993 10.9511 0.927051L12.4697 5.60081C12.6035 6.01284 12.9875 6.2918 13.4207 6.2918H18.335C19.3037 6.2918 19.7065 7.53141 18.9228 8.10081L14.947 10.9894C14.5966 11.244 14.4499 11.6954 14.5838 12.1074L16.1024 16.7812C16.4017 17.7025 15.3472 18.4686 14.5635 17.8992L10.5878 15.0106C10.2373 14.756 9.7627 14.756 9.41221 15.0106L5.43648 17.8992C4.65276 18.4686 3.59828 17.7025 3.89763 16.7812L5.41623 12.1074C5.55011 11.6954 5.40345 11.244 5.05296 10.9894L1.07722 8.10081C0.293507 7.53141 0.696283 6.2918 1.66501 6.2918H6.57929C7.01252 6.2918 7.39647 6.01284 7.53035 5.60081L9.04894 0.927052Z" />
      </svg>
    );
  };
  return (
    <div className={"review-card"}>
      <div className="review-header">
        <img src={image} alt={""} />
        <div className={"reviewer"}>
          <p className={"reviewer-name"}>{name}</p>
          <p className={"reviewer-role"}>{role}</p>
          <div className={"review-rating"}>
            {Array.from({ length: 5 }, (_, index) => (
              <span key={index}>{renderStars(index, rating)}</span>
            ))}
          </div>
        </div>
      </div>
      <p className={"review-text"}>{review}</p>
    </div>
  );
};

export default Card;
